/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import { connect } from 'react-redux';
// actions
import { updatePageDetails, changePage } from '@insticator/insticator-ui';
import { completeResetWithValidation } from 'state/actions/auth_status';
import { getAuthTokenData } from 'state/actions/auth_status';
import { displayMessage } from '@insticator/insticator-ui'; // iui-state
import { displaySuccessMessage, displayErrorMessage } from '@insticator/insticator-ui'; // iui-utils
// component
import CompletePasswordReset from 'pages/auth/completepasswordreset/completepasswordreset';



/* ========== ~~~~~~~~~~ AUTH COMPLETE PASSWORD RESET : CONTAINER ~~~~~~~~~~ ========== */
// map state
const mapStateToProps = ({ authStatus }) => ({
    fields: authStatus.completepasswordreset.fields,
    editable: authStatus.completepasswordreset.editable,
    savingData: authStatus.completepasswordreset.savingData,
    tokenData: authStatus.tokenData
});

// map actions
const mapDispatchToProps = dispatch => ({
    moveToPage: (location) => {
        dispatch(updatePageDetails(location));
        dispatch(changePage(location))
    },
    displayMessage: message => dispatch(displayMessage(message)),
    completeResetWithValidation: (fields, formData, successAction, failAction) =>dispatch(completeResetWithValidation(fields, formData, successAction, failAction)),
    getAuthTokenData: tokenUUID => dispatch(getAuthTokenData(tokenUUID)),
    displayErrorMessage: errorMessage => dispatch(displayErrorMessage(errorMessage)),
    displaySuccessMessage: successMessage => dispatch(displaySuccessMessage(successMessage))
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CompletePasswordReset);
